import { useContext } from 'react';

import { ProductsCatalogContext } from '../Provider';

export const useProductsCatalog = () => {
  const context = useContext(ProductsCatalogContext);

  if (!context) {
    throw new Error(
      'useProductsCatalog must be used within a ProductsCatalogProvider'
    );
  }

  return context;
};
